import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

const root = createRoot(document.getElementById('root')!)
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Intersection Observer for scroll animations
if (typeof window !== 'undefined') {
  const observerCallback = (entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view')
      }
    })
  }

  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px',
  }

  const observer = new IntersectionObserver(observerCallback, observerOptions)

  // Observe all elements with animate-on-scroll class
  const observeElements = () => {
    const elements = document.querySelectorAll('.animate-on-scroll')
    elements.forEach((el) => observer.observe(el))
  }

  // Initial observation
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeElements)
  } else {
    observeElements()
  }

  // Re-observe on route changes
  const reObserve = () => {
    setTimeout(observeElements, 100)
  }

  window.addEventListener('popstate', reObserve)
  
  // Watch for dynamic content
  const mutationObserver = new MutationObserver(reObserve)
  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true,
  })
}
